import React from "react";
import { Link } from "react-router-dom";

export default function ServicesCol() {
  return (
    <div>
      <h3 className="fw-bold mb-4  mt-3">Our Services</h3>
      <ul className="gap-2 d-flex flex-column p-0">
        <li>
          <Link to={"/Lottery-Visa"} className="main-hover">
            الهجرة العشوائية لامريكا
          </Link>
        </li>
        <li>
          <Link to={"/Tourist-Visa"} className="main-hover">
            تأشيرة السياحة لامريكا
          </Link>
        </li>
      </ul>
    </div>
  );
}
